import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import "../css/ShoppingCart.css";
import toggleCart from "../redux/toggleCart";

function ShoppingCart() {
  const [willCartVanish, setWillCartVanish] = useState(false);
  const { customer, shoppingCart } = useSelector((state) => state);
  const [products, setProducts] = useState([]);
  const [warning, setWarning] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getProducts = async () => {
    const newProducts = [];
    for (const product of shoppingCart.content) {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_API_URL}/products/${product.id}`,
      });
      newProducts.push(response.data);
    }
    setProducts(newProducts);
  };
  const closeShoppingCart = async (ev) => {
    if (
      ev.target.className.includes("dark-background") ||
      ev.target.className.includes("bi-x-lg")
    ) {
      setWillCartVanish(true);
      setTimeout(() => {
        dispatch({ type: "TOGGLE_CART_VISIBILITY" });
      }, 800);
    }
  };
  const proceedToCheckOut = () => {
    if (shoppingCart.content.length === 0) return;
    const whereToGo = customer ? "/checkout/1" : "/login";
    dispatch({ type: "TOGGLE_CART_VISIBILITY" });
    if (!customer) dispatch({ type: "TOGGLE_LOGIN_REDIRECTION" });
    navigate(whereToGo);
  };
  const updateApi = async () => {
    if (!customer) return;
    try {
      await axios.patch(
        `${process.env.REACT_APP_API_URL}/orders/change-content`,
        shoppingCart.content,
        {
          headers: { Authorization: `Bearer ${customer.token}` },
        },
      );
    } catch (err) {
      console.log(err);
    }
  };
  const handleIncrement = (productInCart) => {
    const productData = products.find((product) => product.id === productInCart.id);
    const stock = productData.inStock;
    if (productInCart.quantity < stock) {
      setWarning(null);
      dispatch(toggleCart(productData, 1));
      console.log("The quantity of this product has been incremented.");
    } else {
      setWarning(productData.id);
    }
  };
  const handleDecrement = (productInCart) => {
    setWarning(null);
    dispatch(toggleCart(productInCart, -1));
    console.log("The quantity of this product has been decremented.");
  };
  const handleRemove = (product) => {
    setWarning(null);
    dispatch({ type: "REMOVE_PRODUCT", payload: product.id });
    console.log("This product has been removed from the shopping cart.");
  };

  useEffect(() => {
    getProducts();
    updateApi();
    return () => updateApi();
  }, []);

  return (
    <div
      className={`dark-background ${willCartVanish ? "vanishes" : "appears"}`}
      onClick={closeShoppingCart}
    >
      <div className={`shopping-cart ${willCartVanish ? "vanishes" : "appears"}`}>
        <div className="container">
          <div className="py-2 d-flex align-items-center justify-content-between">
            <h2 className="fs-6 me-5 pt-2">SHOPPING CART</h2>
            <i className="align-self-start btn bi bi-x-lg fs-5"></i>
          </div>
        </div>

        <div className="container bg-light pt-3 pb-1">
          {shoppingCart.content.length === 0 ? (
            <p className="text-danger fw-bold mx-2">
              Your cart is empty. Start adding products now!
            </p>
          ) : (
            <ul className="list-group">
              {shoppingCart.content.map((product, index) => (
                <li
                  key={product.id}
                  className="list-group-item border-0 bg-light list-group-item-action"
                >
                  <div className="d-flex align-items-center justify-content-start">
                    {products.length > 0 && (
                      <img
                        src={process.env.REACT_APP_IMG_BASE_URL + products[index].image}
                        alt={product.name}
                        className="w-25"
                      />
                    )}
                    <div className="row ps-2">
                      <div className="col d-flex justify-content-between">
                        <h3 className="fs-6">{shoppingCart.content.length > 0 && product.name}</h3>
                        <i
                          className="bi bi-trash3 cart-action-button"
                          onClick={() => handleRemove(product)}
                        ></i>
                      </div>

                      <div className="d-flex justify-content-between">
                        <div>
                          <div className="d-flex">
                            <i
                              className="bi bi-dash-circle text-secondary cart-action-button"
                              onClick={() => handleDecrement(product)}
                            ></i>
                            <span className="px-2 ">{product.quantity}</span>
                            <i
                              className="bi bi-plus-circle text-secondary cart-action-button"
                              onClick={() => handleIncrement(product)}
                            ></i>
                          </div>
                          {warning === product.id && (
                            <span className="text-danger">OUT OF STOCK</span>
                          )}
                        </div>
                        <p>
                          U$S{" "}
                          <span className="fw-bold">
                            {Math.round(product.sellingPrice * product.quantity * 100) / 100}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
          <hr />
        </div>

        <div className="container pt-4">
          <div className="d-flex align-items-center justify-content-between">
            <p>Subtotal</p>
            <p className="pe-3">
              U$S{" "}
              <span className="fw-bold">
                {shoppingCart.content.reduce((acc, product) => {
                  return Math.round((acc += product.sellingPrice * product.quantity) * 100) / 100;
                }, 0)}
              </span>
            </p>
          </div>
          <a className="d-flex justify-content-center mt-2">
            <button
              className={`btn ${
                shoppingCart.content.length > 0 ? "btn-main" : "btn-secondary"
              } rounded-pill py-2 px-3 confirm-button`}
              onClick={proceedToCheckOut}
            >
              Proceed to checkout
            </button>
          </a>
          <div className="d-flex justify-content-center">
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShoppingCart;
